module.exports = __webpack_public_path__ + "img/atuuta_ag_red.50bff598.svg";